import { GithubInstallationService } from '../../github-installation.service';
import { inject } from '@angular/core';
import { CustomMessageListener } from '@openmfp/portal-ui-lib';

export abstract class GithubTokenMessageListenerService
  implements CustomMessageListener
{
  protected abstract readonly domain: string;

  private githubInstallationService: GithubInstallationService = inject(
    GithubInstallationService,
  );

  messageId(): string {
    return `installation.request.${this.domain}`;
  }

  async onCustomMessageReceived(msg: {
    targetId?: string;
    state?: string;
    appName?: string;
  }): Promise<void> {
    await this.githubInstallationService.executeGithubInstallationFlow(
      this.domain,
      msg.targetId,
      msg.state,
      msg.appName,
    );
  }
}
